import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const MentionsLegales = () => {
    const lastUpdate = "9 septembre 2025"; // Date de dernière mise à jour

    const sections = [
        {
            id: "editeur",
            title: "Éditeur du site",
            content: `
                • Raison sociale : Gestion Freelance
                • Forme juridique : Société par Actions Simplifiée (SAS)
                • Siège social : 5 rue Gabriel Bourdarias, 69200 Vénissieux
                • Téléphone : 06 03 84 73 69
                • Email : contact@gestionfreelance.com
                • Responsable de la publication : HADJ-ARAB SAID
            `
        },
        {
            id: "hebergement",
            title: "Hébergement du site",
            content: `
                Le site est hébergé par :
                • IONOS SARL
                • Adresse : 7, place de la Gare – BP 70109 – 57201 Sarreguemines Cedex – France
                • Téléphone : 09 70 80 89 11
            `
        },
        {
            id: "propriete",
            title: "Propriété intellectuelle",
            content: `
                L’ensemble du contenu du site (textes, images, logos, icônes, etc.) est la propriété exclusive de Gestion Freelance, sauf mentions contraires.
                Toute reproduction, représentation, modification ou diffusion, totale ou partielle, est interdite sans autorisation écrite préalable.
            `
        },
        {
            id: "responsabilite",
            title: "Responsabilité",
            content: `
                Gestion Freelance s’efforce d’assurer l’exactitude des informations publiées sur ce site. 
                Toutefois, l’entreprise ne saurait être tenue responsable d’éventuelles erreurs, omissions ou indisponibilités temporaires.
            `
        },
        {
            id: "rgpd",
            title: "Protection des données personnelles (RGPD)",
            content: `
                Les données collectées via le site (formulaires de contact, demandes de devis, etc.) sont destinées uniquement à la gestion des relations commerciales.
                Conformément au RGPD, l’utilisateur dispose d’un droit d’accès, de rectification et de suppression en écrivant à : contact@gestionfreelance.com.
            `
        },
        {
            id: "cookies",
            title: "Cookies",
            content: `
                Le site peut être amené à utiliser des cookies pour améliorer l’expérience utilisateur et réaliser des statistiques de fréquentation.
                Un bandeau d’information est proposé lors de la première navigation permettant d’accepter ou de refuser les cookies non essentiels.
            `
        },
    ];

    return (
        <>
            <Navbar />
            <main className="min-h-screen bg-white font-Poppins lg:pt-20 pt-10">
                <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-12">
                    {/* En-tête */}
                    <header className="mb-12 text-start">
                        <h1 className="text-3xl sm:text-4xl font-bold lg:text-5xl tracking-tight text-color1 mb-3">
                            Mentions légales
                        </h1>
                        <p className="text-sm sm:text-base text-gray-600 font-thin">
                            Version : {lastUpdate}
                        </p>
                    </header>

                    {/* Sommaire */}
                    <nav
                        aria-label="Sommaire"
                        className="mb-10 rounded-2xl border border-color3 p-6 shadow-sm"
                    >
                        <h2 className="text-lg font-semibold text-color1 mb-4">Sommaire</h2>
                        <ul className="grid gap-3 sm:grid-cols-2">
                            {sections.map((s) => (
                                <li key={s.id}>
                                    <a
                                        href={`#${s.id}`}
                                        className="text-sm sm:text-base text-gray-700 hover:underline"
                                    >
                                        {s.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Contenu */}
                    <div className="space-y-12">
                        {sections.map((s) => (
                            <section key={s.id} id={s.id}>
                                <h3 className="text-2xl sm:text-3xl font-bold text-color1 mb-4 text-start">
                                    {s.title}
                                </h3>
                                <p className="text-gray-700 text-base sm:text-lg leading-relaxed whitespace-pre-line">
                                    {s.content}
                                </p>
                            </section>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default MentionsLegales;
